import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/sharp-light-svg-icons";
import { BACKEND_URL } from "../../constants/globals";

export const AdminDjangoAdminPage = () => {
    return (
        <div className="w-full h-full">
            <div className="flex justify-between py-4 px-10 items-center">
                <h1 className="text-xl">Django Administration Access</h1>
            </div>
            <hr />

            <div className="w-full px-10 py-3">
                <p className="mt-2">
                    You can use this page to access Django Admin to manage users
                    and change platform data.
                </p>
                <div className="mt-2">
                    Notes:
                    <ul className="mt-1 list-disc list-inside">
                        <li>
                            Django Admin sessions are linked to Aershed
                            sessions.
                        </li>
                        <li>
                            Logging out of Aershed will end your Django Admin
                            session.
                        </li>
                    </ul>
                </div>

                <hr className="my-2" />

                <div className="flex">
                    <button
                        onClick={() =>
                            window
                                .open(`${BACKEND_URL}/admin`, "_blank")
                                .focus()
                        }
                        className="px-4 py-2 rounded-lg flex items-center mt-4 bg-slate-300 hover:bg-slate-700 hover:text-white"
                    >
                        Open Django Admin
                        <FontAwesomeIcon
                            icon={faArrowUpRightFromSquare}
                            className="ml-2 w-3 h-3"
                        />
                    </button>
                </div>
            </div>
        </div>
    );
};
